import { fetchWithAuth } from "@/core/data/fetch-with-auth";
import { parseResponse } from "@/core/data/parse-response";

/** `UserMeResponse` from `GET /api/v1/users/me` (OpenAPI field names). */
type UserMeApi = {
  id: string;
  email: string;
  is_active: boolean;
  created_at: string;
};

export const fetchCurrentUser = async () => {
  const res = await fetchWithAuth("/api/v1/users/me");
  return parseResponse<UserMeApi>(res);
};
